import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';

export const authGuard: CanActivateFn = () => {
  if (!environment.production) return true;

  const authService = inject(MsalService);
  const router = inject(Router);

  if (authService.instance.getAllAccounts().length > 0) {
    return true;
  }

  return router.createUrlTree(['/login']);
};
